// extracted by mini-css-extract-plugin
export default {"float":"Popup_float__xlZOw","trigger":"Popup_trigger__bCCKU","pulse":"Popup_pulse__0i2IS"};